import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class HrUserAuthenticationService {
  constructor(private storageService: StorageService, private router: Router) { }
  login(
    objectId:string,
    id: string,
    corporateId: string,
    email: string,
    firstName: string,
    lastName: string,
    phone: string
  ) {
    this.storageService.secureStorage.setItem(
      "currentUserLogin",
      "HrUserLogin"
    );
    this.storageService.secureStorage.setItem("type_user", "hrUser");
    this.storageService.secureStorage.setItem("user_type", "admin");
    this.storageService.secureStorage.setItem("userId", objectId);
    this.storageService.secureStorage.setItem("corporateId", corporateId);
    this.storageService.secureStorage.setItem("hrUserId", id);
    this.storageService.secureStorage.setItem("email", email);
    this.storageService.secureStorage.setItem("firstName", firstName);
    this.storageService.secureStorage.setItem("phone", phone);
    this.storageService.secureStorage.setItem("lastName", lastName);

    
    
    // this.router.navigate(["/products"]);
    // window.location="https://hrmking2.hrmking.com/products"
    // window.history.pushState("", "", "https://hrmking2.hrmking.com/products");
    // window.location.reload();
    return true;
  }
  logout() {
    this.storageService.secureStorage.removeItem("currentUserLogin");
    this.storageService.secureStorage.removeItem("corporateId");
    this.storageService.secureStorage.removeItem("type_user");
    this.storageService.secureStorage.removeItem("hrUserId");
    this.storageService.secureStorage.removeItem("email");
    this.storageService.secureStorage.removeItem("phone");
    this.storageService.secureStorage.removeItem("firstName");
    this.storageService.secureStorage.removeItem("lastName");
    this.storageService.secureStorage.removeItem("packageName");
    this.storageService.secureStorage.removeItem("codeValue");
    this.storageService.secureStorage.removeItem("code");
  }
  public get loggedIn(): boolean {
    return (
      this.storageService.secureStorage.getItem("currentUserLogin") !== null
    );
  }
}
